module.exports = __webpack_public_path__ + "static/img/db.svg";